export default __webpack_public_path__ + "static/media/Stanley Jack.7c3d69de.jpg";